import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getAnalysisType, getUserCountries } from "./analyzeSlice";
import Data from "./data/Data";
import NewCustomer from "./newcustomer/NewCustomer";
import ComponentTests from "./ComponentTests";
import Customer from "./customer/Customer";
import Scenario from "./scenario/Scenario";
import QuotaDetails from "./quotaDetails/QuotaDetails";
import Modifications from "./modifications/Modifications";
import FourPL from "./FourPL/FourPL";
import TradeDetails from "./tradeDetails/TradeDetails";
import IntendedVSDelivered from "./intendedVSDelivered/IntendedVSDelivered";
import GenerateReports from "./GenerateReport/GenerateReports";

export default function AnalyseData() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const global = useSelector((store) => store.global);
  const { drawerOpen } = global;
  const { isLoading, analysisTypes, selectedAnalysisType, countries } = state;

  useEffect(() => {
    if (analysisTypes.length <= 0) {
      dispatch(getAnalysisType());
    }
    if (countries.length <= 0) {
      dispatch(getUserCountries());
    }
  }, []);

  return (
    <Box sx={{ p: 1, maxWidth: drawerOpen ? "1160px" : "95vw" }}>
      {/* LOADING SCREEN */}
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
      {/* <ComponentTests /> */}
      <Header />
      {selectedAnalysisType === "Data" && <Data />}
      {selectedAnalysisType === "New Customer" && <NewCustomer />}
      {selectedAnalysisType === "Customer" && <Customer />}
      {selectedAnalysisType === "Scenario" && <Scenario />}
      {selectedAnalysisType === "Quota Details" && <QuotaDetails />}
      {selectedAnalysisType === "Modifications" && <Modifications />}
      {selectedAnalysisType === "Trade Details" && <TradeDetails />}
      {selectedAnalysisType === "Intended vs Delivered" && (
        <IntendedVSDelivered />
      )}
      {selectedAnalysisType === "4PL export partner" && <FourPL />}
      {selectedAnalysisType === "Backend Reports" && <GenerateReports />}
      {selectedAnalysisType === "Generate Reports" && <GenerateReports />}
    </Box>
  );
}
